import { apiCallAc } from "..";

export function getUsers() {
	return apiCallAc.get("/dashboard/mobile/statistics/subscribed/users");
}

export function getUser(id) {
	return apiCallAc.get(`/dashboard/mobile/statistics/subscribed/users/${id}`);
}
